// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"6c24ad38","466":"94f50197","738":"9f2c74fa","856":"d977c6fd"}[chunkId] + ".chunk.js";
};